import React, { Fragment, useReducer, useEffect, useState, forwardRef } from "react";
import DatePicker from "../../components/Datepicker";
import MaterialSelect from "../../components/MaterialSelect";
import api from "../../services/api";
import MaterialTable from "material-table";
import { TextField, Button } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import * as XLSX from 'xlsx';
import { makeStyles } from "@material-ui/core/styles";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { TableChart, PictureAsPdf } from "@material-ui/icons";
import PictureAsPdfTwoToneIcon from '@material-ui/icons/PictureAsPdfTwoTone';

const initialState = {
  cnpj: "",
  businessName: "",
  EmployeeName: "",
  EmployeeStatus: "",
  validityDate: null,
  scheduleDate: null,
  page: 1
};

function reducer(filter, { field, value }) {
  return {
    ...filter,
    [field]: value
  };
};

const useStyles = makeStyles({
  pdf: {
    marginTop: "10px",
    marginLeft: "20px",
  },
  groupButtons: {
    marginLeft: "15px"
  },
});

const IntegrationsReport = () => {
  const classes = useStyles();
  const [filter, dispatch] = useReducer(reducer, initialState);
  const [dataIntegrations, setIntegrations] = useState({
    load: true,
    integrationsSchedules: [],
    documentsAttached: [],
    employeeStatuses: [],
    columns: [
      { title: "Empresa", field: "businessName" },
      { title: "CNPJ", field: "cnpj" },
      { title: "Colaborador", field: "EmployeeName" },
      { title: "Status Colab.", field: "EmployeeStatus" },
      { title: "Data integração", field: "scheduleDate" },
      { title: "Vencimento", field: "validityDate" }
    ],
    validityDate: null,
    toValidityDate: null,
    scheduleDate: null
  });

  const onChange = e => {
    const { name, value } = e.target;
    dispatch({ field: name, value: value });
  };

  useEffect(() => {
    fetchAPI();
  }, []);

  const fetchAPI = async () => {
    setIntegrations({ ...dataIntegrations, load: true });
    const integrationsRequest = `/integration-schedules`;
    const employeeStatusRequest = "/employee-status";

    const integrationResponse = await api.get(integrationsRequest);
    const employeeStatusResponse = await api.get(employeeStatusRequest);

    const formatedAttachs = await formatData(integrationResponse.data.rows);

    setIntegrations({
      ...dataIntegrations,
      integrationsSchedules: formatedAttachs,
      employeeStatuses: employeeStatusResponse.data.rows,
      documentsAttached: formatedAttachs,
      load: false
    });
  };

  const formatData = async integrations => {
    return await integrations.map(item => {
      return {
        businessName: item.Employee.Company.businessName
          ? item.Employee.Company.businessName
          : "Não definido",
        cnpj: item.Employee.Company.cnpj
          ? item.Employee.Company.cnpj
          : "Não definido",
        EmployeeName: item.Employee.name ? item.Employee.name : "Não informado",
        EmployeeStatus: item.Employee.EmployeeStatus.description,
        validityDate: item.validityDate
          ? moment.utc(item.validityDate).format("DD/MM/YYYY")
          : "Não definido",
        scheduleDate: moment.utc(item.Integration.date).format("DD/MM/YYYY")
      };
    });
  };

  const setValidityDate = e => {
    setIntegrations({ ...dataIntegrations, validityDate: e });
  };
  
  const setToValidityDate = e => {
    setIntegrations({ ...dataIntegrations, toValidityDate: e });
  };
  
  const setScheduleDate = e => {
    setIntegrations({ ...dataIntegrations, scheduleDate: e });
  };

  const searchIntegrations = async () => {
    setIntegrations({ ...dataIntegrations, load: true });
    const validity_date = dataIntegrations.validityDate
      ? `&validityDate=${dataIntegrations.validityDate}`
      : "";
    const toValidity_date = dataIntegrations.toValidityDate
      ? `&toValidityDate=${dataIntegrations.toValidityDate}`
      : "";
    const schedule_Date = dataIntegrations.scheduleDate
      ? `&date=${dataIntegrations.scheduleDate}`
      : "";
    const businessName = filter.businessName
      ? `&businessName=${filter.businessName}`
      : "";
    const cnpj = filter.cnpj ? `&cnpj=${filter.cnpj}` : "";
    const EmployeeName = filter.EmployeeName
      ? `&EmployeeName=${filter.EmployeeName}`
      : "";

    const EmployeeStatus = filter.EmployeeStatus
      ? `&EmployeeStatus=${filter.EmployeeStatus}`
      : "";
    const integrationsRequest = `/integration-schedules/?page=1${businessName}${cnpj}${EmployeeName}${EmployeeStatus}${validity_date}${toValidity_date}${schedule_Date}`;

    const integrationResponse = await api.get(integrationsRequest);

    const formatedData = await formatData(integrationResponse.data.rows);

    setIntegrations({
      ...dataIntegrations,
      integrationsSchedules: formatedData,
      load: false
    });
  };

  const customPdfButton = () => {
    const title = "DPWCDI Report - Integrações";
    const fileName = `DPWCDI Report Integrações - ${moment().format(
      "DD/MM/YYYY"
    )}`;

    // Build date range subtitle if dates are provided
    let dateRangeText = "";
    if (dataIntegrations.validityDate || dataIntegrations.scheduleDate) {
      const validityDate = dataIntegrations.validityDate ? moment(dataIntegrations.validityDate).format("DD/MM/YYYY") : "...";
      const scheduleDate = dataIntegrations.scheduleDate ? moment(dataIntegrations.scheduleDate).format("DD/MM/YYYY") : "...";
      dateRangeText = `Período: ${scheduleDate} - ${validityDate}`;
    }

    const headers = [
      [
        "Empresa",
        "CNPJ",
        "Colaborador",
        "Status Colab.",
        "Data Integração",
        "Vencimento"
      ]
    ];

    const data = dataIntegrations.documentsAttached.map(item => [
      item.businessName,
      item.cnpj,
      item.EmployeeName,
      item.EmployeeStatus,
      item.scheduleDate,
      item.validityDate
    ]);

    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);
    let currentY = 20;

    // Add title
    doc.text(title, marginLeft, currentY);
    currentY += 20;

    // Add date range if provided
    if (dateRangeText) {
      doc.setFontSize(12);
      doc.text(dateRangeText, marginLeft, currentY);
      currentY += 15;
    }

    let content = {
      startY: currentY + 10,
      head: headers,
      body: data
    };

    doc.autoTable(content);
    doc.save(fileName);
  };

  const exportToExcel = () => {
    // Create workbook
    const wb = XLSX.utils.book_new();
    
    // Prepare headers and data
    const headers = ['Empresa', 'CNPJ', 'Colaborador', 'Status Colab.', 'Data Integração', 'Vencimento'];
    const data = dataIntegrations.documentsAttached.map(item => [
      item.businessName,
      item.cnpj,
      item.EmployeeName,
      item.EmployeeStatus,
      item.scheduleDate,
      item.validityDate
    ]);

    // Build date range text if dates are provided
    let dateRangeText = "";
    if (dataIntegrations.validityDate || dataIntegrations.scheduleDate) {
      const validityDate = dataIntegrations.validityDate ? moment(dataIntegrations.validityDate).format("DD/MM/YYYY") : "...";
      const scheduleDate = dataIntegrations.scheduleDate ? moment(dataIntegrations.scheduleDate).format("DD/MM/YYYY") : "...";
      dateRangeText = `Período: ${scheduleDate} - ${validityDate}`;
    }

    // Create worksheet structure with title and optional date range
    let worksheetData = [
      [], // Empty row
      ['DPWCDI Report - Integrações'], // Title
      [`Gerado em: ${moment().format('DD/MM/YYYY HH:mm')}`] // Generation date
    ];

    // Add date range if provided
    if (dateRangeText) {
      worksheetData.push([dateRangeText]);
    }

    // Add empty row and headers
    worksheetData.push([], headers, ...data);

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Calculate merges based on whether date range is included
    const titleRowIndex = 1;
    const dateGenRowIndex = 2;
    const dateRangeRowIndex = dateRangeText ? 3 : -1;
    const headerRowIndex = dateRangeText ? 5 : 4;

    // Merge cells for title, generation date, and optional date range
    ws['!merges'] = [
      { s: { r: titleRowIndex, c: 0 }, e: { r: titleRowIndex, c: 5 } }, // Title spans columns A-F
      { s: { r: dateGenRowIndex, c: 0 }, e: { r: dateGenRowIndex, c: 5 } } // Generation date spans columns A-F
    ];

    // Add date range merge if it exists
    if (dateRangeText) {
      ws['!merges'].push({ s: { r: dateRangeRowIndex, c: 0 }, e: { r: dateRangeRowIndex, c: 5 } });
    }

    // Set column widths
    ws['!cols'] = [
      { wch: 30 },  // Empresa
      { wch: 18 },  // CNPJ
      { wch: 25 },  // Colaborador
      { wch: 15 },  // Status Colab.
      { wch: 15 },  // Data Integração
      { wch: 15 }   // Vencimento
    ];

    // Style header row with blue background and white text
    headers.forEach((header, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: headerRowIndex, c: index });
      if (ws[cellRef]) {
        ws[cellRef].s = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '1e88e5' } },
          alignment: { horizontal: 'center', vertical: 'center' }
        };
      }
    });

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Integrações');

    // Generate filename with current date
    const fileName = `DPWCDI_Report_Integracoes_${moment().format('DD-MM-YYYY')}.xlsx`;

    // Save file
    XLSX.writeFile(wb, fileName);
  };

  const tableIcons = {
    Export: forwardRef((props, ref) => (
      <Button
        size="small"
        className={"btn-info"}
        startIcon={<TableChart {...props} ref={ref} color="action" />}
        onClick={exportToExcel}
      >
        XLS
      </Button>
    )),
    DetailPanel: () => null,
    SortArrow: () => null
  };

  const { EmployeeName, businessName, cnpj } = filter;

  return (
    <Fragment>
      <div className="col-md-12">
        {/* Filtros empresa */}
        <h3 className="card-title mt-1">Filtros da empresa e colaborador</h3>
        <hr />
        <div className="row mb-2 p-20">
          <div className="col-md-2">
            <TextField
              name="businessName"
              label="Razão Social"
              value={businessName}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <TextField
              name="cnpj"
              label="CNPJ"
              value={cnpj}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <TextField
              name="EmployeeName"
              label="Nome colaborador"
              value={EmployeeName}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              name="EmployeeStatus"
              dateLabel="Status colaborador"
              value={dataIntegrations.EmployeeStatus}
              data={dataIntegrations.employeeStatuses}
              onChange={onChange}
            />
          </div>
          <div className="col-md-6"></div>
        </div>
        <hr />
        {/* Filtros documentos */}
        <h3 className="card-title mt-4">Filtros das Integrações</h3>
        <hr />
        <div className="row mb-2 p-20">
          <div className="col-md-2 ">
            <DatePicker
              name="scheduleDate"
              data={dataIntegrations.scheduleDate}
              onChange={e => setScheduleDate(e)}
              dateLabel="Data integração:"
            />
          </div>
          <div className="col-md-2">
            <DatePicker
              name="validityDate"
              data={dataIntegrations.validityDate}
              onChange={e => setValidityDate(e)}
              dateLabel="Validade:"
            />
          </div>
          <div className="col-md-2">
            <DatePicker
              name="toValidityDate"
              data={dataIntegrations.toValidityDate}
              onChange={e => setToValidityDate(e)}
              dateLabel="Validade até:"
            />
          </div>
        </div>
        <div className="row mb-2 ">
          <div className="col-md-10" />
          <div className="col-md-2" className={classes.groupButtons}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={"btn-info"}
              startIcon={<SearchIcon />}
              onClick={searchIntegrations}
            >
              Pesquisar
            </Button>
            <Button
              size="small"
              className={"btn-info"}
              startIcon={<PictureAsPdfTwoToneIcon />}
              onClick={customPdfButton}
              className={classes.pdf}
            >
              PDF
            </Button>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12 mt-1">
            <MaterialTable
              title=""
              icons={tableIcons}
              isLoading={dataIntegrations.load}
              options={{
                exportButton: true,
                exportAllData: true,
                defaultExpanded: true,
                exportCsv: (columns, renderData) => {
                  // Override default CSV export to use our Excel function
                  exportToExcel();
                }
              }}
              localization={{
                pagination: {
                  labelDisplayedRows: "{from}-{to} de {count}",
                  labelRowsSelect: "linhas",
                  firstTooltip: "Primeira",
                  previousTooltip: "Anterior",
                  nextTooltip: "Próxima",
                  lastTooltip: "Última"
                },
                body: {
                  emptyDataSourceMessage: "Não há dados a serem exibidos"
                },
                header: {
                  actions: "Ações"
                },
                grouping: {
                  groupedBy: "Agrupado por:",
                  placeholder: "Arraste os cabeçalhos aqui para agrupar"
                },
                toolbar: {
                  nRowsSelected: "{0} linha(s) selecionada(s)",
                  searchPlaceholder: "Pesquisar",
                  exportTitle: "Exportar para Excel",
                  exportName: "Exportar para Excel"
                }
              }}
              columns={dataIntegrations.columns}
              data={dataIntegrations.integrationsSchedules}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default IntegrationsReport;
